<template>
  <el-table ref="multipleTable" :data="tableData" style="width: 100%;color: black;" class="--modal-table"
    @selection-change="handleSelectionChange">
    <el-table-column type="selection" :selectable="checkSelectable">
    </el-table-column>
    <el-table-column label="Uploaded Date">
      <template slot-scope="scope">{{ scope.row.date }}</template>
    </el-table-column>
    <el-table-column property="name" label="Audience Name">
    </el-table-column>
    <el-table-column property="total" label="Total Audience" show-overflow-tooltip>
    </el-table-column>
    <!-- <el-table-column property="status" label="Audience Status" show-overflow-tooltip>
      <template slot-scope="scope">
        <span :style="{ color: scope.row.status === 'error' ? 'red' : 'inherit' }">
          {{ scope.row.status }}
        </span>
      </template>
    </el-table-column> -->
    <el-table-column label="Action" align="right">
      <template slot-scope="scope">
        <i
          :disabled="disabled || removingAudienceIds[scope.row.id]" :class="removingAudienceIds[scope.row.id] ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-trash'"
            :style="{
            cursor: (disabled || removingAudienceIds[scope.row.id]) ? 'not-allowed' : 'pointer',
            pointerEvents: (disabled || removingAudienceIds[scope.row.id]) ? 'none' : 'auto',
            opacity: disabled ? 0.5 : 1
          }"
          @click="handleRemoveAudience(scope.row.id)">
        </i>
              <!-- <div @click.stop>
          <el-dropdown trigger="click">
            <span class="menu-drop-anchor">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div @click.stop="">
                <el-dropdown-item>Remove</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
      </template>
    </el-table-column>
  </el-table>

</template>

<script>
import {
  Table, TableColumn, Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui';
import { mapActions } from 'vuex/dist/vuex.common.js';
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    userId: {
      // type: [String, Number],
      required: true,
    },
    selectedAudienceIds: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      isSelectionProgrammatic: false,
      removingAudienceIds: {}
    }
  },

  methods: {
    ... mapActions(['SimplifiGetAudience']),
    async refresh() {
      await this.getAudience(this.userId);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      if (this.isSelectionProgrammatic) return;
      this.multipleSelection = val;
      this.$emit('selection-changed', val);
    },
    checkSelectable(row, index) {
      if (this.disabled) {
        return false;
      }
      return (row.status == 'finish' || row.status == 'queue');
    },
    async handleRemoveAudience(audienceId) {
      this.$set(this.removingAudienceIds, audienceId, true);

      let payload = { audience_id: audienceId };
      try {
        const response = await this.$store.dispatch('SimplifiRemoveAudience', payload);
        if (response.result === 'success') {
          this.$notify({
            type: 'success',
            message: 'Data has been removed successfully',
            icon: 'far fa-trash'
          });
          this.getAudience(this.userId);
        }
      } catch (error) {
        if (error.status == 422) {
          this.$notify({
            type: 'danger',
            message: error.message,
            icon: 'fas fa-cancel'
          });
        } else {
          this.$notify({
            type: 'primary',
            message: error.message,
            icon: 'fas fa-bug'
          });
        }
      } finally {
        // hapus loading untuk row ini
        this.$delete(this.removingAudienceIds, audienceId);
      }
    },
    async getAudience(userId) {
      const payloadGetAudience = {
        user_id: userId,
        selected_campaign_audience: []
      };
      try {
        const response = await this.SimplifiGetAudience({ data: payloadGetAudience });
        if (response.result === 'success') {
          this.tableData = response.audiences;
        } else {
          this.tableData = [];
        }
      } catch (error) {
        this.tableData = [];
      }
      this.setSelection(this.selectedAudienceIds);
    },
    setSelection(selectedIds) {      
      if (!this.$refs.multipleTable || !Array.isArray(selectedIds)) {
        return;
      }
      this.$nextTick(() => {
        try {
          this.isSelectionProgrammatic = true;
          const selectedIdSet = new Set(selectedIds.map(id => Number(id)));
          this.$refs.multipleTable.clearSelection();
          const initiallySelectedRows = [];
          this.tableData.forEach(row => {
            if (selectedIdSet.has(row.id)) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
              initiallySelectedRows.push(row);
            }
          });

          if (initiallySelectedRows.length) {
            this.$emit('selection-changed', initiallySelectedRows);
          }

        } finally {
          this.$nextTick(() => {
            this.isSelectionProgrammatic = false;
          });
        }
      });
    }
  },
  mounted(){
    // this.getAudience(this.userId)
  },
  watch: {
    userId: {
      immediate: true,
      handler(newVal) {
        if (newVal != '') {
          this.getAudience(newVal);
        }
      }
    }
  }
}
</script>
<style>
.--modal-table.el-table table {
  color: unset !important;
}
</style>